import * as devisConf from '@/configuration/devisConf';

export default function validationSansSuite(response, messages, type, codeDevisCommande) {
  if (!response.data.error || !response.data.error.validationErrors || !type) {
    return;
  }
  let i18nType = '';
  switch (type) {
    case devisConf.TYPE_COMMANDE:
      i18nType = 'validationCommande';
      break;
    case devisConf.TYPE_DEVIS:
      i18nType = 'validationDevis';
      break;
    default:
      i18nType = '';
      break;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORBIDDEN_IF_DEPOSIT_ON_ORDER') === 0) {
      messages.push({
        message: i18nType + (codeDevisCommande ? '.sansSuiteForbiddenWithOrderWithCode' : '.sansSuiteForbiddenWithOrder'),
        parametres: {
          code: codeDevisCommande,
        },
      });
    }
    if (message.indexOf('FORBIDDEN_ON_RENEWED_TACIT') === 0) {
      messages.push({
        message: i18nType + '.sansSuiteForbidenRenewedActif',
      });
    }
    if (message.indexOf('CLOSING_FORBIDDEN_IF_LOGISTIC_ASSIGNMENT_VALIDATED_WITH_OT') === 0) {
      messages.push({
        message: i18nType + '.sansSuiteForbidenWithOrdreTravail',
      });
    }
    if (message.indexOf('CLOSING_FORBIDDEN_IF_LOGISTIC_ASSIGNMENT_VALIDATED_WITH_TFS') === 0) {
      messages.push({
        message: i18nType + '.sansSuiteForbidenWithTfs',
      });
    }
    if (message.indexOf('SAVED_STATE_REQUIRED') === 0) {
      messages.push({
        message: i18nType + (codeDevisCommande ? '.savedStateRRequiredWithCode' : '.savedStateRRequired'),
        parametres: {
          code: codeDevisCommande,
        },
      });
    }
    if (message.indexOf('DEVIS_NOT_TO_MOVE_STATUS_FOLLOW_UP_OR_DELETE_IT') === 0) {
      messages.push({
        message: i18nType + (codeDevisCommande ? '.SansSuiteForbiddenMoveWithCode' : '.SansSuiteForbiddenMove'),
        parametres: {
          code: codeDevisCommande,
        },
      });
    }
    if (message.indexOf('DEVIS_COMMANDE_SANS_SUITE_DELETE_FORBIDDEN_IF_BLOCAGE_VALIDATION|') === 0) {
      messages.push({
        message: i18nType + '.SansSuiteForbiddenMoveWithValidationBlocage',
      });
    }
  });
}
